import React from 'react'
import { Form, Formik } from 'formik'
import { required } from '../../utils/validators'
import Input from '../../components/common/Input'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'
import { useLoad } from '../../hooks/request'
import { EMPLOYEES_LIST } from '../../urls'

export default function EmployeeSalaryForm({ onCancel, onSubmit, initialValues, loading }) {
    const employee = useLoad({ url: EMPLOYEES_LIST, params: { size: 1000 } })
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                employee: '',
                paymentDate: '',
                amount: '',
                daysWorked: '',
                month: '',
                year: new Date().getFullYear(),
                note: '',
                ...initialValues,
            }}
        >
            <Form>
                <Select name="employee" label="Ходим" options={employee.response ? employee.response.results : []} validate={required} />
                <Input name="paymentDate" label="Тўлов санаси" type="date" validate={required} />
                <Input name="amount" label="Миқдор" type="number" validate={required} />
                <Input name="daysWorked" label="Ишланган кунлар" type="number" />
                <Select
                    options={[
                        { value: 'january', name: 'Январь' },
                        { value: 'february', name: 'Февраль' },
                        { value: 'march', name: 'Март' },
                        { value: 'april', name: 'Апрель' },
                        { value: 'may', name: 'Май' },
                        { value: 'june', name: 'Июнь' },
                        { value: 'july', name: 'Июль' },
                        { value: 'august', name: 'Август' },
                        { value: 'september', name: 'Сентябрь' },
                        { value: 'october', name: 'Октябрь' },
                        { value: 'november', name: 'Ноябрь' },
                        { value: 'december', name: 'Декабрь' },
                    ]}
                    optionValue="value"
                    optionLabel="name"
                    name="month"
                    label="Ой"
                    validate={required}
                />
                <Input name="year" label="Йил" type="number" validate={required} />
                <Input name="note" label="Изоҳ" type="textarea" />
                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button onClick={onCancel} icon="close-outline" text="Бекор қилиш" className="is-danger" />
                    </div>
                    <div className="button-wrapper">
                        <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </div>
            </Form>
        </Formik>
    )
}
